import $ from 'jquery';
import BaseController from 'chairisher/_controller';

import { observeIntersectionForEls } from 'chairisher/view/helper/intersectionobserver';
import { trackNavLinks, trackPageView } from 'chairisher/analytics/sustainability';

// Array of supported years. If year payload is not present in URL we will default to last entry
const supportedYears = ['2021', '2022'];

/**
 * Controller that binds actions for the sustainability resale report microsite
 *
 * @class SustainabilityController
 * @constructs SustainabilityController
 */
class SustainabilityController extends BaseController {
    /** @inheritDoc */
    initControllerState() {
        super.initControllerState();

        const urlArr = window.location.href.split('/');
        const payload = urlArr[urlArr.length - 1];
        this.year = supportedYears.sort().indexOf(payload) !== -1 ? payload : supportedYears[supportedYears.length - 1];

        this.bindMobileNavigation();
        this.bindNavLinksScrollStyle();
        this.setQuoteCarousel();
    }

    /** @inheritDoc * */
    bindPageAnalytics() {
        trackPageView(this.year);
        // year should be implicit in URLs
        trackNavLinks(this.year);
    }

    /**
     * Binds the appropriate elements for the mobile navigation view
     */
    bindMobileNavigation() {
        const $navButton = $('#js-mobile-nav-btn');
        const $navLinks = $('.js-nav-link-mobile');
        const $navMenu = $('.js-nav-menu-mobile');

        function toggleMobileNavMenu() {
            $navMenu.toggleClass('nav-menu-mobile-open');
            $navButton.toggleClass('cicon-x');
            $navButton.toggleClass('cicon-hamburger');
        }

        $navButton.add($navLinks).on('click', () => {
            toggleMobileNavMenu();
        });
    }

    /**
     * Binds the appropriate scroll styles for the desktop navigational links
     */
    bindNavLinksScrollStyle() {
        const $navLinks = $('.js-nav-link-desktop');
        const $subsections = $(
            '.js-foreword, .js-chapter1, .js-chapter2, .js-chapter3, .js-chapter4, .js-chapter5, .js-chapter6',
        );

        observeIntersectionForEls($subsections, (entry) => {
            const idx = entry.target.attributes['data-chapter-idx'].value;
            $navLinks.removeClass('scrolled');
            $navLinks.eq(idx).addClass('scrolled');
        });
    }

    /**
     * Sets the carousel functionality for the Industry Insiders quotes (Chapter 1 - Subsection 11)
     * Includes the auto transitions, pause ability and left and right navigations
     */
    setQuoteCarousel() {
        const $arrowLeft = $('.js-quote-chevron-left');
        const $arrowRight = $('.js-quote-chevron-right');
        let interval;
        const $quotes = $('.js-quote-industry-insiders');
        let quoteIdx = 0; // defaults to 1st quote
        const $section = $('#js-quote-carousel-section');

        //
        // Functions
        //

        function displayCurrentQuote() {
            $quotes.addClass('quote-hide');
            $quotes.eq(quoteIdx).removeClass('quote-hide');
        }

        function nextQuote() {
            quoteIdx = quoteIdx < $quotes.length - 1 ? quoteIdx + 1 : 0;
            displayCurrentQuote();
        }

        function prevQuote() {
            quoteIdx = quoteIdx === 0 ? $quotes.length - 1 : quoteIdx - 1;
            displayCurrentQuote();
        }

        function setCarouselInterval() {
            interval = setInterval(() => {
                nextQuote();
            }, 10000);
        }

        //
        // Interval
        //

        // resolves glitch bug where 1st quote was momentarily displayed between initial load and interval
        let isFirstCycle = true;
        if (isFirstCycle) {
            $quotes.eq(quoteIdx).removeClass('quote-hide');
            isFirstCycle = false;
        }

        if (this.year === '2021') {
            setCarouselInterval();
            $section.mouseenter(() => {
                clearInterval(interval);
            });

            $section.mouseleave(() => {
                setCarouselInterval();
            });
        }

        //
        // Event Actions
        //

        $arrowLeft.click(() => {
            prevQuote();
        });

        $arrowRight.click(() => {
            nextQuote();
        });
    }
}

export default SustainabilityController;
